<template>
  <div class="config__background config__background--blue">
    <div class="container__main config__container">
      <div class="config__display">
        <div class="config__content config__content--full">
          <h1 class="feedback__title">🚀 {{ t("title") }}</h1>
          <div class="feedback__content">
            <h2 class="feedback__subtitle">{{ t("subtitle") }}</h2>
            <p class="feedback__p">
              {{ t("descr[0]") }} <br />
              {{ t("descr[1]") }}
            </p>
          </div>
          <div
            v-if="$store.state.loggedIn"
            class="feedback__content feedback__content--border"
          >
            <h3 class="feedback__subtitle">
              {{ t("feedbacktitle") }}
            </h3>
            <div class="feedback__input">
              <textarea-input
                :inputdata="textareaData"
                :modelValue="feedback"
                @updateForm="updateFeedback"
                style="width: 100%"
              ></textarea-input>
              <label class="feedback__input--checkbox">
                {{ t("public") }}
                <input
                  type="checkbox"
                  name="feedback-check"
                  value="private"
                  v-model="publicFeedback"
                  class="feedback__input--checkbox-input"
                />
                <div class="feedback__input--checkbox-box"></div>
              </label>
              <div>
                <button
                  class="btn"
                  :class="{
                    'btn--blue': readySubmit,
                    'btn--grey-light': !readySubmit,
                  }"
                  @click="submit"
                >
                  <loading-button :loading="submitting">{{
                    t("share")
                  }}</loading-button>
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <login-required> {{ t("needlogin") }}</login-required>
          </div>
          <div class="feedback__content">
            <h3 class="feedback__subtitle">
              {{ t("publictitle") }}
            </h3>
            <div class="fbk" v-for="f in feedbacks" :key="f._id">
              <p>
                {{ f.message }}
              </p>
              <div class="fbk__by">
                <router-link
                  :to="{
                    name: 'User',
                    params: {
                      slug: f.createdBy.slug
                        ? f.createdBy.slug
                        : f.createdBy._id,
                    },
                  }"
                  class="fbk__author fbk__by--item"
                >
                  <img
                    :src="
                      `${$store.state.apiUrl}/images/profil/thumbnail/${
                        f.createdBy.profilePicture.split('.')[0]
                      }.webp`
                    "
                    alt=""
                    class="fbk__author--img"
                  />
                  <div class="fbk__author--text">{{ f.createdBy.name }}</div>
                </router-link>
                <div class="fbk__by--item">
                  {{
                    moment(f.createdAt)
                      .locale(locale)
                      .fromNow()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import TextareaInput from "../components/form/TextareaInput.vue";
import axios from "axios";
import moment from "moment";
import LoadingButton from "../components/utils/LoadingButton";
import LoginRequired from "../components/utils/LoginRequired";

import Comment from "../components/comment/Comment";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import en from "@/locales/en/feedback.json";
import fr from "@/locales/fr/feedback.json";

export default {
  components: {
    Comment,
    LoadingButton,
    LoginRequired,
    TextareaInput,
  },
  setup() {
    const form = ref({});
    const publicFeedback = ref(true);
    const readySubmit = ref(false);
    const feedbacks = ref([]);
    const submitting = ref(false);
    const feedback = ref(null);

    const { t, locale } = useI18n({
      messages: {
        en: en,
        fr: fr,
      },
    });

    const store = useStore();
    const textareaData = {
      name: "feedback",
      placeholder: "Type your feedback here",
    };

    onMounted(() => {
      getAllFeedbacks();
    });

    const getAllFeedbacks = async () => {
      try {
        const result = await axios({
          method: "GET",
          url: "feedbacks",
        });
        feedbacks.value = result.data.data.data;
      } catch (err) {
        console.log(err.response);
      }
    };

    const isReadySubmit = () => {
      readySubmit.value = form.value.feedback ? true : false;
    };

    const resetForm = () => {
      feedback.value = "";
      publicFeedback.value = true;
    };

    const updateFeedback = (value) => {
      if (value.value) {
        form.value[value.field] = value.value.trim();
      } else {
        delete form.value[value.field];
      }

      isReadySubmit();
    };

    const submit = async () => {
      if (readySubmit.value) {
        submitting.value = true;
        try {
          const result = await axios({
            method: "POST",
            url: "feedbacks",
            data: {
              message: form.value.feedback,
              isPrivate: !publicFeedback.value,
            },
          });
          if (result.status === 201) {
            submitting.value = false;

            if (publicFeedback.value) {
              const data = result.data.data.data;
              data.createdBy = store.state.user;
              feedbacks.value.splice(0, 0, data);
            }

            store.dispatch("showAction", {
              message: t("success"),
              color: "green",
            });
            resetForm();
          }
          console.log(result);
        } catch (err) {
          console.log(err.response);
        }
        console.log("submit");
      } else {
        console.log("not ready to submit");
      }
    };

    return {
      feedback,
      feedbacks,
      locale,
      moment,
      textareaData,
      publicFeedback,
      readySubmit,
      submit,
      submitting,
      t,
      updateFeedback,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../style/main";
@import "../style/components/config";

.fbk {
  padding: 2rem;
  box-shadow: $shadow;
  border: 1px solid currentColor;
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
  & p {
    margin-bottom: 1.6rem;
  }

  &__by {
    display: flex;
    align-items: center;

    &--item {
      position: relative;
      &:not(:last-child) {
        margin-right: 2rem;
        &::before {
          color: currentColor;
          position: absolute;
          top: 50%;
          left: calc(100% + 1rem);
          content: "\2022";

          transform: translate(-50%, -50%);
        }
      }
    }
  }

  &__author {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
    &--img {
      height: 2rem;
      width: 2rem;
      border-radius: 50%;
      margin-right: 1rem;
    }
  }
}

.feedback {
  &__title {
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    font-weight: 400;
    font-size: 2.6rem;
    //   text-align: center;
    margin-bottom: 2.5rem;
  }
  &__subtitle {
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    font-weight: 700;
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
  &__subsubtitle {
    margin-top: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    font-weight: 400;
    font-size: 1.6rem;
  }

  &__content {
    margin-bottom: 3rem;

    &--border {
      padding-bottom: 2rem;
      border-bottom: 2px solid $color-blue-light;
    }
  }

  &__p {
    font-size: 1.4rem;
    font-weight: 300;
  }

  &__input {
    display: flex;
    flex-direction: column;
    // justify-content: center;

    @include respond(phone) {
      flex-direction: column;
    }

    $checkbox-dim: 2.2rem;

    &--checkbox {
      position: relative;
      margin: 1rem 0rem 2rem calc(#{$checkbox-dim} + 1rem);
      cursor: pointer;

      &:hover &-input ~ &-box {
        background-color: rgba(0, 0, 0, 0.2);
      }

      &:hover &-input:checked ~ &-box {
        background-color: $color-blue;
      }

      &-input {
        display: none;
      }

      &-box {
        height: $checkbox-dim;
        width: $checkbox-dim;
        border: 1px solid $color-blue-light;
        position: absolute;

        top: 50%;
        left: calc(-#{$checkbox-dim} - 1rem);

        transform: translate(0, -50%);

        &:after {
          display: none;
          content: "";
          position: absolute;

          left: 0.7rem;
          top: 0.2rem;
          width: 0.7rem;
          height: 1.4rem;
          border: solid white;
          border-width: 0 0.3rem 0.3rem 0;
          transform: rotate(45deg);
        }
      }
      &-input:checked ~ &-box {
        background-color: $color-blue-light;
      }

      &-input:checked ~ &-box:after {
        display: block;
      }
    }
  }
}
</style>
